import { useMemo } from "react";
import { animeList } from "@/mocks/anime";
import AnimeCard from "@/components/feature/AnimeCard";
import SectionHeading from "@/components/feature/SectionHeading";

export default function LatestAnime() {
  const latest = useMemo(
    () => [...animeList].sort((a, b) => b.popularity - a.popularity).slice(0, 8),
    []
  );

  return (
    <section className="bg-background-100/70 border-y border-background-200/60">
      <div className="mx-auto max-w-[1280px] px-4 md:px-8 py-12 md:py-16">
        <SectionHeading
          title="最新动漫更新"
          subtitle="热门连载持续更新，追番不掉队"
          icon="ri-history-line"
          moreTo="/category/hot-blood"
          moreLabel="更多资源"
        />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-5">
          {latest.map((anime) => (
            <AnimeCard key={anime.id} anime={anime} />
          ))}
        </div>
      </div>
    </section>
  );
}